module.exports = __webpack_public_path__ + "static/media/sero-shirts.829f3da0.jpg";